/* eslint-disable import/no-anonymous-default-export */
import http from "./httpService";

import { default as apiConfing } from "../config.json";
import { AxiosResponse } from "axios";
import { ConversationProps, MessageProps } from "../typings/messages";
import imageCompression from "browser-image-compression";
const apiUrl = apiConfing.IS_DEVELOPMENT
  ? apiConfing.API_DEVELOPMENT
  : apiConfing.API_PRODUCTION;

const apiEndpoint = `${apiUrl}/Messages`;

export function hideConversation(
  memberCode: number,
  recieverMemberCode: number,
): Promise<AxiosResponse> {
  const url = `${apiEndpoint}/HideConversation?memberCode=${memberCode}&recieverMemberCode=${recieverMemberCode}`;
  return http.get(url);
}

export function showConversation(
  memberCode: number,
  recieverMemberCode: number,
): Promise<AxiosResponse> {
  const url = `${apiEndpoint}/ShowConversation?memberCode=${memberCode}&recieverMemberCode=${recieverMemberCode}`;
  return http.get(url);
}

export function getConverstaionList(
  memberCode: number,
): Promise<AxiosResponse<ConversationProps[]>> {
  const url = `${apiEndpoint}/getConverstaionList?memberCode=${memberCode}`;
  return http.get(url);
}

export function getMessagesBetweenMembers(
  memberCode: number,
  chatMemberCode: number,
): Promise<AxiosResponse<MessageProps[]>> {
  const url = `${apiEndpoint}/GetMessagesBetweenMembers?memberCode=${memberCode}&chatUserId=${chatMemberCode}`;
  return http.get(url);
}

export function sendLocationMesssage(
  data: any,
): Promise<AxiosResponse<MessageProps>> {
  const url = `${apiEndpoint}/SendLocationMesssage`;
  return http.put(url, data);
}

export function sendBreakTheIceMesssage(
  data: any,
): Promise<AxiosResponse<MessageProps>> {
  const url = `${apiEndpoint}/SendBreakTheIceMesssage`;
  return http.put(url, data);
}

export function answerBreakTheIceMessage(
  data: any,
): Promise<AxiosResponse<MessageProps>> {
  const url = `${apiEndpoint}/AnswerBreakTheIceMesssage`;
  return http.put(url, data);
}

export function sendTextMesssage(
  data: any,
): Promise<AxiosResponse<MessageProps>> {
  const url = `${apiEndpoint}/SendTextMesssage`;
  return http.put(url, data);
}

export async function sendImageMesssage(
  memberCode: number,
  chatMemberCode: number,
  File: any,
): Promise<AxiosResponse<MessageProps>> {
  const url = `${apiEndpoint}/SendImageMesssage?memberCode=${memberCode}&chatUserId=${chatMemberCode}`;
  let formData;
  try {
    const options = {
      maxSizeMB: 0.2,
      maxWidthOrHeight: 1000,
      useWebWorker: true,
    };
    const compressedFile = await imageCompression(File, options);
    formData = getFromData(compressedFile);
  } catch (error) {
    throw new Error("An error occurred while compressing the image");
  }
  return http.post(url, formData);
}

export function sendProfileImagesMessage(
  memberCode: number,
  chatMemberCode: number,
  images: any,
): Promise<AxiosResponse<MessageProps>> {
  const url = `${apiEndpoint}/SendProfileImagesMessage?memberCode=${memberCode}&chatUserId=${chatMemberCode}`;
  return http.post(url, images);
}

function getFromData(file: any) {
  const formData = new FormData();
  formData.append("formdata", file);
  return formData;
}

export default {
  getConverstaionList,
  getMessagesBetweenMembers,
  sendTextMesssage,
  sendLocationMesssage,
  sendProfileImagesMessage,
  sendBreakTheIceMesssage,
  answerBreakTheIceMessage,
};
